<template>
	<div class="box01">
		<v-crumbs :crumbsType="70"></v-crumbs>
		<div class="offer_top flex02">
			<div class="flex03">
				<div class="btn01 m_r10" @click="clickAdd">新增</div>
			</div>
		</div>
		<div class="form_box">
			<div style="flex: 1;overflow: hidden;">
				<template>
					<el-table ref="multipleTable" :data="list" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" fixed width="46"></el-table-column>
						<el-table-column prop="id" label="ID" width="70"></el-table-column>
						<el-table-column prop="name" label="凭证类型"></el-table-column>
						<el-table-column prop="createtime_text" label="添加时间"></el-table-column>
						<el-table-column fixed="right" label="操作">
							<template slot-scope="scope">
								<div class="flex04">
									<!-- <p class="c_6d9fff m_r10 pointer_">查看</p> -->
									<p class="c_6d9fff m_r10 pointer_" @click="clickEdit(scope.row)">编辑</p>
									<p class="c_ff6f6f pointer_" @click="clickDel(scope.row)">删除</p>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</template>
				<div class="pagination">
					<el-pagination background :page-size="fromInfo.limit" :current-page="fromInfo.page" layout="prev, pager, next, jumper"
					 :total="total" @current-change="currentChange"></el-pagination>
				</div>
			</div>
			<!-- <div class="form_right_nav_wrapper">
				<v-right-nav :index="0"></v-right-nav>
			</div> -->
		</div>
		<!-- 新建 -->
		<el-dialog
		  :title="title" custom-class="zxb-dialog" :visible.sync="dialogVisible" width="30%" center>
		  <el-input v-model="editVal" placeholder="请输入"></el-input>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="submitEnd">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import crumbs from '../../components/crumbs/index.vue'; // 面包屑
	import select01 from '../../components/select/index.vue'; // 选择器
	import select02 from '../../components/select/index01.vue'; // 搜索框
	import screen from '../../components/screen/index.vue'; // 高级搜索
	import rightNav from '../../components/nav/index.vue'; // 右侧导航
	import modal from '../../components/set-modal/index.vue'; // 新建模态

	import {
		voucherIndexApi,voucherSaveApi,voucherEditApi,voucherDelApi
	} from '@/api/index';

	export default {
		components: {
			'v-crumbs': crumbs,
			'v-select01': select01,
			'v-select02': select02,
			'v-screen': screen,
			'v-right-nav': rightNav,
			'v-modal': modal
		},
		data() {
			return {
        title:'',
				list: [],
				total: null,
				isState: '',
				editVal: '',
        editId:'', //修改id
        editIdx:null, //修改下标
				idList: [],
				dialogVisible: false,
				fromInfo: {
					page: 1,
					limit: 10
				},
			}
		},
		created() {
			this.getTypeList()
		},
		methods: {
			// 获取列表
			getTypeList() {
        console.log('11111111')
				voucherIndexApi(this.fromInfo).then(res => {
					this.total = res.data.total
					this.list = res.data.data
				})
			},
			// 点击页码数
			currentChange(newPage) {
				this.fromInfo.page = newPage;
				this.getTypeList();
				window.scroll(0, 0);
			},
			// 添加
			clickAdd() {
				this.isState = 'add';
        this.title = "新增";
				setTimeout(()=>{
          this.dialogVisible = true
        },200)
			},
			// 编辑
			clickEdit(val) {
				this.editVal = val.name;
        this.editId = val.id;
        this.editIdx = this.list.findIndex(n=>n.id === val.id);
				this.isState = 'edit';
        this.title = "编辑";
				this.dialogVisible = true
			},
			// 模态叉号
			getModalClose(e) {
				this.editVal = ''
				this.dialogVisible = e
			},
			// 添加、修改成功
			submitEnd() {
				if (this.isState === 'add') {
					this.fromInfo.page = 1;
          voucherSaveApi({name:this.editVal}).then(res=>{
            this.$message.success('新增成功');
            this.getTypeList()
            this.dialogVisible = false
            this.editVal = '';
          })
				}else{
          voucherEditApi({name:this.editVal,id:this.editId}).then(res=>{
            this.list[this.editIdx].name = this.editVal;
            this.editId = '';
            this.dialogVisible = false
            this.editVal = '';
            this.$message.success('修改成功')
          })
        }
			},
			// 删除
			clickDel(id) {
				this.$confirm('确定删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					voucherDelApi(id).then(res => {
						if (this.fromInfo.page != 1 && this.list.length == 1) {
							this.fromInfo.page--
						}
						this.getTypeList()
						this.$message.success('删除成功')
					})
				})
			},
			// 复选按钮
			handleSelectionChange(e) {
				let arr = []

				if (e.length) {
					e.forEach(val => {
						arr.push(val.id)
					})
				}

				this.idList = arr; // 选中的id
			},
		}
	}
</script>

<style lang="less" scoped>
	.offer_top {
		margin-bottom: 15px;
	}
	
	.form_box {
		display: flex;
	}
</style>
